// extracted by mini-css-extract-plugin
export default {"planTitle":"XQwvSK","featureIcon":"XabSPX","domainFeatureChip":"JPqVlW","domainFeatureChipText":"mUyT0I","cardFixedHeight":"xYD9N1","featureTooltip":"n1x2ZY"};